export default {
    0: '校对失败',
    101: '缺少必填的参数，首先确保必填参数齐全，然后，确认参数书写是否正确。',
    102: '不支持的语言类型',
    103: '翻译文本过长',
    104: '不支持的API类型',
    105: '不支持的签名类型',
    106: '不支持的响应类型',
    107: '不支持的传输加密类型',
    108: '应用ID无效，注册账号，登录后台创建应用，可获得应用ID和应用密钥等信息',
    109: 'batchLog格式不正确',
    110: '无相关服务的有效应用，。注：某些服务的结果发音需要tts服务，需要在控制台创建语音合成实例绑定应用后方能使用。',
    111: '开发者账号无效',
    112: '请求服务无效',
    113: 'q不能为空',
    114: '不支持的图片传输方式',
    201: '解密失败，可能为DES,BASE64,URLDecode的错误',
    202: '签名检验失败，如果确认应用ID和应用密钥的正确性，仍返回202，一般是编码问题。请确保翻译文本 q 为UTF-8编码.',
    203: '访问IP地址不在可访问IP列表',
    205: '请求的接口与应用的平台类型不一致，确保接入方式（Android SDK、IOS SDK、API）与创建的应用平台类型一致。如有疑问请参考入门指南',
    206: '因为时间戳无效导致签名校验失败',
    207: '重放请求',
    301: '辞典查询失败',
    302: '翻译查询失败',
    303: '服务端的其它异常',
    304: '会话闲置太久超时',
    401: '账户已经欠费停',
    402: 'offlinesdk不可用',
    411: '访问频率受限,请稍后访问',
    412: '长请求过于频繁，请稍后访问',
    29001: 'inputType 类型不对',
    29002: 'needTypo 类型不对',
    29003: 'Q 超过限制长度',
    29004: 'grade 类型不对',
    29005: '文件为空',
    29006: '图片过大',
    29007: '作文批改的文本内容为空',
    29008: 'isNeedSynonyms参数错误',
    29009: 'ocr识别结果为空',
    29301: '作文批改请求失败',
};
